import type { FollowStatus } from '@/components/OrganizerCard/types';
import Cookies from 'cookies-js';
import { HAS_WINDOW } from '@eventbrite/feature-detection';

// Return default state to avoid breaking the UI
export const DEFAULT_FOLLOW_STATUS_RESPONSE: FollowStatus = {
  followedByYou: false,
  numFollowers: 0,
};

export const getButtonState = (
  followStatusLoading: boolean,
  followStatus: FollowStatus | null,
  followActionLoading: boolean,
) => {
  const hasValidData = followStatus !== null;
  const shouldShowLoading = followStatusLoading || !hasValidData;
  const isLoading = shouldShowLoading || followActionLoading;

  return {
    hasValidData,
    shouldShowLoading,
    isLoading,
  };
};

// Cookie management for organizer follow after login
export const ORGANIZER_COOKIE = 'ebOrganizerId';

const getUrlPath = (): string => {
  if (!HAS_WINDOW) {
    return '/';
  }
  return window.location.pathname;
};

/**
 * Saves organizer ID to cookie for follow action after login
 * @param organizerId - The organizer ID to save
 */
export const saveOrganizerIdInCookie = (organizerId: string): void => {
  if (!HAS_WINDOW) {
    return;
  }

  Cookies.set(ORGANIZER_COOKIE, organizerId, {
    path: getUrlPath(),
    secure: true,
    expires: 300,
  });
};
